const showMoreBtn = document.getElementById('product-grid-showmore');

const handleShowMore = () => {
	document
		.querySelectorAll('.block-products-grid__grid-item.d-none')
		.forEach((element, index) => {
			if (index <= 3) {
				element.classList.remove('d-none');
			}
		});
	if (showMoreBtn) {
		showMoreBtn.style.display =
			document.querySelectorAll('.block-products-grid__grid-item.d-none').length < 1
				? 'none'
				: '';
	}
};

showMoreBtn?.addEventListener('click', handleShowMore);
